import { render, staticRenderFns } from "./successTrash.vue?vue&type=template&id=ddde44c0"
import script from "./successTrash.vue?vue&type=script&lang=js"
export * from "./successTrash.vue?vue&type=script&lang=js"
import style0 from "./successTrash.vue?vue&type=style&index=0&id=ddde44c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports